<template>
  <div
    class="answers"
    data-toggle="buttons"
    :class="{ opacity: answered.length > 3 }"
  >
    <span role="region" aria-live="polite" class="sr-only">
      {{
        (answered.length > 0 ? labels.acessibilityAlertInfo : '')
          | parse({
            INFO: acessibilityAlertInfo,
            ANSWERED_LENGTH: answered.length,
            SURVEY_LIMIT_CHOICES: question.surveyLimitVotes,
            SELECTED_CHOICES: selectedChoices,
            SELECTED_CHOICES_LABELS: selectedChoicesLabels,
          })
      }}
    </span>

    <span role="region" aria-live="polite" class="sr-only">
      {{ acessibilityAlertWarning }}
    </span>

    <b-row class="ie-11-radio-string-row">
      <b-col class="flex">
        <div
          class="check-item hovered"
          :class="{
            checked:
              answered.filter(a => a.answer_id === answer.answer_id).length > 0,
          }"
          v-for="(answer, index) in answers"
          :key="index"
          @click="select(answer)"
        >
          <div
            class="item"
            :title="answers[index].text"
            role="button"
            :tabindex="index + 4"
            :aria-pressed="
              answered.filter(a => a.answer_id === answer.answer_id).length > 0
                ? 'true'
                : 'false'
            "
            @keydown.enter.space="select(answer)"
            :id="'option' + (index + 1)"
          >
            <div
              class="check"
              :class="{
                'mdi mdi-check-circle':
                  answered.filter(a => a.answer_id === answer.answer_id)
                    .length > 0,
              }"
            ></div>
          </div>
          <label class="text" aria-hidden="true" :for="'option' + (index + 1)">
            {{ answers[index].text }}
          </label>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  question: {
    type: Object,
    required: true,
    validator: function(question) {
      if (!Array.isArray(question.answers)) return false
      return true
    },
  },
}

export default {
  props: props,
  data() {
    return {
      acessibilityAlertWarning: '',
      imageUrl: 'https://static.teamculture.com.br/images/culture/$ID$.svg',
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    answered: function() {
      return this.question.answered || []
    },
    answers: function() {
      return this.question.answers || []
    },
    labels() {
      return this.resources.component.checkBoxString
    },
    acessibilityAlertInfo() {
      return this.question.surveyLimitVotes === this.answered.length
        ? this.labels.acessibilityAnswerMaxLimitWarning
        : ''
    },
    selectedChoices() {
      return this.answered.length > 0
        ? this.labels.acessibilitySelectedChoices
        : ''
    },
    selectedChoicesLabels() {
      const hasAnswer = this.answered.length > 0
      const choicesLabels = this.answered.map(a => a.text).join(', ')
      const endSetenceText = hasAnswer ? '.' : ''
      return choicesLabels + endSetenceText
    },
  },
  methods: {
    select(answer) {
      if (
        this.answered.length >= this.question.surveyLimitVotes &&
        this.answered.filter(a => a.answer_id === answer.answer_id).length === 0
      ) {
        this.acessibilityAlertWarning =
          answer.text + ' ' + this.labels.acessibilityAlertWarning
        return
      }
      this.acessibilityAlertWarning = ''
      answer.type = 'multi'
      this.$emit('answer', answer)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

_:-ms-fullscreen,
:root .ie-11-radio-string-row {
  width: 100%;
}

.flex {
  max-width: 75vw;
  overflow: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  @media (max-width: 767px) {
    flex-direction: column-reverse;
    align-items: center;
  }

  @media (max-width: 425px) {
    min-height: 350px;
  }

  .check-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    @media (max-width: 767px) {
      flex-direction: row;
      margin-bottom: 10px;
    }

    .text {
      display: inline-block;
      color: rgba(112, 112, 112, 0.7);
      font-size: 13px;
      font-weight: 500;
      width: 100px;
      cursor: pointer;
      margin-top: 20px;

      @media (max-width: 425px) {
        margin: 0;
      }
    }

    .circle {
      border-radius: 50%;
      transition: all ease-in-out 0.1s;
      width: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: map-get($theme-colors, 'lima');
    }

    .item {
      border: 1.3rem solid map-get($theme-colors, 'gray-light');
      height: 90px;
      width: 90px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all ease 0.2s;
      cursor: pointer;

      @media (max-width: 767px) {
        border: 0.95rem solid #f0f0f0;
        height: 60px;
        width: 60px;
      }

      .check {
        border-radius: 50%;
        transition: all ease-in-out 0.1s;
        width: 0px;
        height: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 60px;
        color: map-get($theme-colors, 'lima');

        @media (max-width: 767px) {
          font-size: 40px;
        }
      }
    }

    &:hover {
      .text {
        color: map-get($theme-colors, 'primary');
      }
    }

    &.checked {
      .item .check {
        width: 100%;
        height: 100%;
        border: solid 1px rgba(0, 168, 119, 0.5);
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
      }

      .text {
        color: map-get($theme-colors, 'primary');
      }
    }
  }
}
</style>
